module.exports = __webpack_public_path__ + "static/media/hraswo_pi.4da35b39.ogg";